var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.languages,"label":"Select Language","item-text":"text","item-value":"value","dense":"","outlined":""},on:{"input":event => { _vm.emitChange(event) }},model:{value:(_vm.selectedLang),callback:function ($$v) {_vm.selectedLang=$$v},expression:"selectedLang"}})
}
var staticRenderFns = []

export { render, staticRenderFns }